import React, {Component} from 'react';
import {connect} from 'react-redux';
import AiYearLogo from '../AiYearLogo';
import SocialLink from '../SocialLink';


class KsuThreeTemplateRTL extends Component {

    render() {

        return (
            <div dir='rtl' style={{minWidth:'600px', maxWidth:'600px', width: '600px'}} data-signature-root="true">
                <div style={{display: 'flex'}}>
                    <div id="photo" style={{width: '150px', flex: '0 0 150px', textAlign: 'center'}}>
                        <img src={this.props.imageName}  style={{maxWidth:'90px',paddingBottom:'15px'}} alt={this.props.name} border={0} />
                    </div>
                    <div style={{textAlign: 'center'}}>
                        <div style={{marginLeft: '14px'}}>
                            <div style={{fontSize:'25px'}}>
                                {!this.props.flag ? 'محمد عبدالله' : this.props.name}
                            </div>
                            <div>
                                <div>{!this.props.flag ? 'القسم' : this.props.department}</div>
                                <div>
                                    {!this.props.flag ?
                                        <>
                                            <img style={{width: '15px'}} src={`${process.env.PUBLIC_URL}/mobile.png`} alt={'mobile'} />
                                            &nbsp;
                                            011/055
                                        </> :
                                        <>
                                            <img style={{width: '15px'}} src={`${process.env.PUBLIC_URL}/mobile.png`} alt={'mobile'} hidden={this.props.mobile === ''}/>
                                            &nbsp;
                                            {this.props.mobile}
                                        </>}
                                </div>
                                <div>
                                    {!this.props.flag ?
                                        <>
                                            <img style={{width:'15px'}} src={`${process.env.PUBLIC_URL}/email.png`} alt={'email'}/>
                                            &nbsp;
                                            m.abdullah@ksu.edu.sa
                                        </> :
                                        <>
                                            <img style={{width:'15px'}} src={`${process.env.PUBLIC_URL}/email.png`} alt={'email'} hidden={this.props.email === ''}/>
                                            &nbsp;
                                            {this.props.email}
                                        </>}
                                </div>
                                <div>{!this.props.flag ? 'https://ksu.edu.sa' : this.props.website}</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div style={{backgroundColor:"#0084BD", display: 'flex', width: '100%'}}>
                    <div style={{paddingLeft: '10px', width:'45%'}} >
                        <div style={{display: 'flex', alignItems: 'center'}}>
                            <hr width={1} size={60} style={{display: 'inline-block', borderRight: '3px solid gray', margin: 0, marginLeft: '10px', marginRight: '10px', borderBottom: '0px', borderLeft: '0px', borderTop: '0px'}} />

                            <img src={`${process.env.PUBLIC_URL}/ksu_logo_foot.png`} alt="ksu logo" style={{width: '120px'}} />
                            <AiYearLogo noTopMargin style={{width: '80px', marginRight: '0', marginTop: '0', verticalAlign: 'middle'}}/>
                        </div>
                    </div>
                    <div style={{flex: 1, textAlign: 'right'}}>
                        <div style={{marginTop:'10px', width: '100%', backgroundColor:"#ffffff"}} >
                            
                            <div style={{paddingRight:'10px'}}>
                                <div className='d-flex flex-wrap align-items-center'>
                                    {!this.props.flag ?
                                    <div className='d-inline mr-2'>
                                        <a className='d-flex align-items-center' target="_blank" rel="noopener noreferrer" href='https://www.linkedin.com'>
                                            <img className='mr-1' style={{width:'30px'}} src={`${process.env.PUBLIC_URL}/linkedin.png`} alt={'linkedin'}/>
                                        </a>
                                    </div>
                                        : (this.props.linkedin !== '' && <SocialLink href={this.props.linkedin} icon={`${process.env.PUBLIC_URL}/linkedin.png`} alt={'linkedin'} width={'30px'}/>)}&nbsp;&nbsp;
                                    {!this.props.flag ?
                                        <div className='d-inline mr-2'>
                                            <a className='d-flex align-items-center' target="_blank" rel="noopener noreferrer" href='https://www.x.com'>
                                                <img className='mr-1' style={{width:'30px'}}  src={`${process.env.PUBLIC_URL}/x.svg`} alt={'X'}/>
                                            </a>
                                        </div>
                                        : (this.props.twitter !== '' && <SocialLink href={this.props.twitter} icon={`${process.env.PUBLIC_URL}/x.svg`} alt={'X'} width={'30px'}/>)}&nbsp;&nbsp;

                                    {!this.props.flag ?
                                    <div className='d-inline mr-2'>
                                        <a className='d-flex align-items-center' target="_blank" rel="noopener noreferrer" href='https://www.facebook.com/'>
                                            <img className='mr-1' style={{width:'30px'}}  src={`${process.env.PUBLIC_URL}/facebook.png`} alt={'facebook'}/>
                                        </a>
                                    </div>
                                        : ( this.props.facebook !== '' && <SocialLink href={this.props.facebook} icon={`${process.env.PUBLIC_URL}/facebook.png`} alt={'facebook'} width={'30px'}/>)}&nbsp;&nbsp;

                                    {/* {!this.props.flag ?
                                        (<a target="_blank" rel="noopener noreferrer" href='https://www.github.com/'><img style={{width: '30px'}} src={`${process.env.PUBLIC_URL}/github.png`} alt={'github'}/></a>
                                        ): (this.props.github !== '' && <a target="_blank" rel="noopener noreferrer" href={this.props.github}><img style={{width:'30px'}}  src={`${process.env.PUBLIC_URL}/github.png`} alt={'github'}/></a>)}&nbsp;&nbsp; */}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        flag: state.ArabicReducer.flag,
        name: state.ArabicReducer.ar_name,
        email: state.ArabicReducer.ar_email,
        jobTitle: state.ArabicReducer.ar_jobTitle,
        department: state.ArabicReducer.ar_department,
        mobile: state.ArabicReducer.ar_mobile,
        website: state.ArabicReducer.ar_website,
        imageName: state.imageReducer.image,
        linkedin: state.socialReducer.linkedin,
        twitter: state.socialReducer.twitter,
        facebook: state.socialReducer.facebook,
        github: state.socialReducer.github,
    };
}

export const ksuThreeTemplateRTL =  connect(mapStateToProps)(KsuThreeTemplateRTL);
